/****************************************************
 * Module Name:  cluletMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import CluletProxy from "../../utility/proxy/manager/cluletProxy";
import AddCluletModal from "./addCluletModal";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class CluletMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clulets: [],
      showAddCluletModal: false,

      editOperation: false,
      sourceData: {},
      errorSnackbar: false,
      loadingButton: false,
      accesDenied: false,
      showCluletLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_CLULET
      ),
    };

    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("MASTER_CLULET");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchCluletData(false);
    }
  }


  fetchCluletData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showCluletLoadSpinner: true });
    CluletProxy.GetAllClulet((responseData) => {
      if (responseData) {
        this.setState({ clulets: responseData, showCluletLoadSpinner: false })
      } else {
        this.setState({ errorSnackbar: true, showCluletLoadSpinner: false })
      }
    }
    );
  };

  columns = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      minWidth: 50,
    },
    {
      field: "name",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "fullname",
      headerName: "CULET FULLNAME",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "description",
      headerName: "DESCRIP",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "webref",
      headerName: "WEB REFERENCE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      minWidth: 50,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({
                showAddCluletModal: true,
                editOperation: true,
                sourceData: params.row,
                loadingButton: false,
              });
            }}
          >
            {" "}
            <BorderColorIcon color="primary" />
          </Box>
        );
      },
    },
  ];

  hideAddCluletModal = () => {
    this.setState({
      showAddCluletModal: false,
    });
  };

  handleValidation = (cluletData) => {
    //TODO do validation if needed here
    return true;
  };

  addClulet = (cluletData) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Updating Clulet, and once clulet is updated on call refresh the list of current clulets
      CluletProxy.UpdateClulet(cluletData, (response) => {
        if (response) {
          this.fetchCluletData(true);
          //Hidding clulet modal
          this.hideAddCluletModal();
          this.setState({ loadingButton: false });
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    } else {
      //Creating new Clulet, and once clulet is created on call refresh the list of current clulets
      CluletProxy.AddClulet(cluletData, (response) => {
        if (response) {
          this.fetchCluletData(true);
          //Hidding clulet modal
          this.hideAddCluletModal();
          this.setState({ loadingButton: false });
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    }
  };

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
          {this.state.showCluletLoadSpinner ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchCluletData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}
          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Add Culet">
              <Button
                color="info"
                variant="outlined"
                size="small"
                sx={{ ml: "5px" }}
                onClick={() =>
                  this.setState({
                    showAddCluletModal: true,
                    editOperation: false,
                    sourceData: {},
                  })
                }
                startIcon={<AddBoxOutlinedIcon size="large" />}
              >
                Culet
              </Button>
            </Tooltip>
          ) : null}
          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      );
    }
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.clulets;
    const columns = Utility.isUpdateAllowed(this.state.local_Permission)
      ? this.columns
      : this.columns.filter((col) => col.field !== "edit");
    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        <br />
        {this.state.showAddCluletModal ? (
          <AddCluletModal
            Show={true}
            handleClose={this.hideAddCluletModal}
            handleSave={this.addClulet}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}

        <Box px={1}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "85vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{ toolbar: CustomToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              loading={this.state.showCluletLoadSpinner}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
}

export default CluletMaster;
